{
  "ru": {
    "countdownTimer": {
      "days": "дней | день | дня | дней",
      "hour": "час",
      "min": "мин",
      "sec": "сек"
    }
  },
  "kk": {
    "countdownTimer": {
      "days": "күн",
      "hour": "сағ",
      "min": "мин",
      "sec": "сек"
    }
  },
  "en": {
    "countdownTimer": {
      "days": "days | day | days | days",
      "hour": "hour",
      "min": "min",
      "sec": "sec"
    }
  }
}
